import apiService from '../Api'
import { CommercialConsultant, CommercialConsultantInput } from './types'

export class CommercialConsultantService {
  async list(): Promise<CommercialConsultant[]> {
    return apiService.get('/commercial-consultant').then((res) => res.data)
  }

  async get(id: number): Promise<CommercialConsultant> {
    return apiService.get(`/commercial-consultant/${id}`).then((res) => res.data)
  }

  async create(data: CommercialConsultantInput): Promise<CommercialConsultant> {
    return apiService.post('/commercial-consultant', data).then((res) => res.data)
  }

  async update(id: number, data: CommercialConsultantInput): Promise<CommercialConsultant> {
    return apiService.put(`/commercial-consultant/${id}`, data).then((res) => res.data)
  }

  async updateEnabled(id: number, enabled: boolean): Promise<CommercialConsultant> {
    return apiService
      .put(`/commercial-consultant/${id}/enabled`, { enabled })
      .then((res) => res.data)
  }

  async delete(id: number): Promise<void> {
    return apiService.delete(`/commercial-consultant/${id}`)
  }
}
